
/**
 * This method will save the login Cookies
 * @param {JsonLoginDetails :login user details}
 */
const CreateLoginDetailsCookie = (AuthKey, JsonLoginDetails) => {
    const IsCookieSaved = new Promise((resolve, reject) => {
        try {
            if (JsonLoginDetails) {
                const reqParam = { JsonLoginDetails };

                fetch('/Login/SaveLoginCookie', {
                    method: 'POST',
                    headers: {
                        'Authorization': AuthKey,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(reqParam),
                    async: true
                }).then((response) => (response.json())
                    .then(jsonResult => {
                        console.log('CreateLoginDetailsCookie Success Result ', jsonResult);
                        resolve(jsonResult);
                    })).catch(err => {
                        console.error('Error in fetch url /Login/SaveLoginCookie ', err);
                        reject(0);
                    })

            }
            else {
                reject(0);
            }
        } catch (err) {
            console.error('Error in CreateLoginDetailsCookie: ', err);
            reject(0);
        }
    });
    return IsCookieSaved;
}

export default CreateLoginDetailsCookie;
